import React, { memo, Fragment } from 'react'
import ContentLoader from 'react-content-loader'

const TravelDocumentSkeleton = (props) => {

    return (

        <Fragment>
            <section className="check-out static-page" key={`traveldocskeleton-1`}>
                <div className="check-out-width">
                    <div className="logo">
                        <ContentLoader className="traveldoc-nav-skeleton"
                            height={75}
                            width={'100%'}
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            {...props}
                        >
                            <rect x="0%" y="25%" rx="0" ry="0" width="35%" height="25" /> {/*logo */}
                            <rect x="60%" y="25%" rx="0" ry="0" width="35%" height="25" /> {/*number */}

                        </ContentLoader>
                    </div>
                </div>
            </section>

            <section className="static-page-wrapper" key={`traveldocskeleton-2`}>
                <div className="static-width">
                    <div className="static-page">

                        <ContentLoader className="static-banner"
                            height={'100%'}
                            width={'100%'}
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            {...props}
                        >
                            <rect x="0%" y="0%" rx="0" ry="0" width="100%" height="100%" />


                        </ContentLoader>
                        <div className="static-full-width-content">
                            <div className="static-container" style={{ height: `500px` ,scrollBehavior:`none`}}>
                                <ContentLoader
                                    height={'100%'}
                                    width={'100%'}
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    {...props}
                                >
                                    <rect x="0%" y="0%" rx="0" ry="0" width="100%" height="20%" /> {/*Static full width */}

                                    <rect x="0%" y="30%" rx="0" ry="0" width="50%" height="8%" /> {/*Head 1*/}
                                    <rect x="0%" y="43%" rx="0" ry="0" width="40%" height="5%" /> {/* Data Lines start*/}
                                    <rect x="55%" y="43%" rx="0" ry="0" width="50%" height="5%" /> {/* Data Lines end*/}

                                    <rect x="0%" y="50%" rx="0" ry="0" width="40%" height="5%" /> {/* Data Lines start*/}
                                    <rect x="55%" y="50%" rx="0" ry="0" width="50%" height="5%" /> {/* Data Lines end*/}
                                    <rect x="0%" y="57%" rx="0" ry="0" width="40%" height="5%" /> {/* Data Lines start*/}
                                    <rect x="55%" y="57%" rx="0" ry="0" width="50%" height="5%" /> {/* Data Lines end*/}

                                    <rect x="0%" y="64%" rx="0" ry="0" width="40%" height="5%" /> {/* Data Lines start*/}
                                    <rect x="55%" y="64%" rx="0" ry="0" width="50%" height="5%" /> {/* Data Lines end*/}
                                    <rect x="0%" y="71%" rx="0" ry="0" width="40%" height="5%" /> {/* Data Lines start*/}
                                    <rect x="55%" y="71%" rx="0" ry="0" width="50%" height="5%" /> {/* Data Lines end*/}


                                    <rect x="0%" y="85%" rx="0" ry="0" width="50%" height="8%" /> {/* Head 2*/}
                                    <rect x="0%" y="98%" rx="0" ry="0" width="40%" height="5%" /> {/* Data Lines start*/}
                                    <rect x="55%" y="98%" rx="0" ry="0" width="50%" height="5%" /> {/* Data Lines end*/}

                                </ContentLoader>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
        </Fragment>

    )
}

export default memo(TravelDocumentSkeleton)
